<template>
    <div class="expandy-content" :class="{'can-collapse': canCollapse, expanded: expanded}">
        <div class="expandable" :class="{expanded: expanded || !collapsedHeight}" :style="styles">
            <div class="inner" ref="content">
                <slot></slot>
            </div>
        </div>
        <div class="toggle-expanded" v-if="canCollapse">
            <span class="show-more toggler interactive uc" @click="expanded = true">Show more<svg-icon id="chevronDown"></svg-icon></span>
            <span class="show-less toggler interactive uc" @click="expanded = false">Show less<svg-icon id="chevronUp"></svg-icon></span>
        </div>
    </div>
</template>

<script>
import throttle from 'lodash/throttle';

export default {
    
    props: {
		collapsedHeight: {
			type:       Number,
            default:    120,
		},
    },
    
    data() {
		return {
			expanded:	        false,
            canCollapse:        false,
        };
    },
    
    computed: {
        styles() {
            if ( this.collapsedHeight !== null ) {
                return {
                    'max-height':   ((!this.expanded && this.canCollapse) ? this.collapsedHeight : this.fullHeight) + 'px',
                };
            }
            
            return {};
        },
    },
    
    created() {
        window.addEventListener('resize', this.recalculate);
    },
    
    mounted() {
        this.recalculate();
    },
    
    beforeDestroy() {
        window.removeEventListener('resize', this.recalculate);
    },
    
    
    
    methods: {
        recalculate() {
            this.canCollapse = this.$refs.content.offsetHeight > this.collapsedHeight;
            this.fullHeight = this.$refs.content.offsetHeight;
        },
    },
    
};
</script>